import React from "react";
import {isValidString} from "../../utils";
import {useTranslation} from "react-i18next";
import {Modal} from "../Modal";
import LoadingComponent from "../LoadingComponent";
import { LoadingContainer } from "./styles";

interface LoadingPopupProps {
    isOpen: boolean,
    title?:string,
    subtitle?:string
}

export const PopupLoading = ({isOpen, title, subtitle}: LoadingPopupProps) => {

    const {t} = useTranslation()

    return <Modal isOpen={isOpen}>
        <LoadingContainer>
            <h1>{isValidString(title) ? title : t('loading_please_wait') as string}</h1>
            {isValidString(subtitle) ? <p>{subtitle}</p> : null}
            <LoadingComponent/>
        </LoadingContainer>
    </Modal>
}
